const Icon: React.FC<IconProps> = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 3593.8 3600"
      xmlSpace="preserve"
      width="30px"
      height="30px"
    >
      <g>
        <g id="XMLID_1_">
          <g>
            <path
              className="st0"
              style={{ fill: "transparent" }}
              d="M1756.5,76.2C2742.4,54,3550.3,859,3524.2,1853.5c-23.8,906.6-767.9,1688.3-1748.8,1678.4
				c-934.6-9.4-1703.3-766.5-1708-1728.5C73.1,842.8,837.4,97,1756.5,76.2z M3014.3,1755.6c91.6-67.9,147.2-155.8,136.1-274.5
				c-10.8-116.3-69.7-202.8-176.3-249.9c-115.3-50.9-225.6-36.5-324.5,44.3c-11.3,9.2-18.2,9.6-29.8,2
				c-183.4-120.9-385.4-188.6-603.4-210.7c-24.4-2.5-48.8-5.1-76.8-8c47.3-147.4,93.5-291,140.1-436c11.2,1.8,20.2,2.8,29,4.7
				c111.3,23.9,222.4,48.6,333.9,71.3c23,4.7,34.3,12.7,40.8,36.9C2514.2,850,2628,922.9,2743,904.4
				c158.1-25.5,243.9-195.8,167.3-332.2c-61.2-109-251.7-174.2-374.4-31.5c-12.1,14-22.3,17.3-40.1,13.4
				c-144.5-31.7-289.2-62.1-433.9-93c-60.1-12.9-88.2,3.6-106.7,62.4c-52.2,165.6-104.6,331.2-156.6,496.8
				c-4.5,14.3-8.2,24.8-27.6,24.7c-97.6-0.6-193.8,13.2-289.2,33.3c-171.1,36.2-330.3,100.8-474.9,199.5c-13.2,9-21.3,5.3-33.4-0.2
				c-49.5-22.9-97.9-51.4-150-65.2c-180.4-47.8-394.6,98.8-357.7,339.7c14.5,94.7,70.8,163.2,148.4,215.2
				c12.7,8.5,15.6,16.2,13.3,30.2c-21.8,130.3-8.2,256.7,44.4,378.3c74.8,173,203.4,297.9,359.8,396.5
				c178.4,112.6,376.3,169.6,583.8,195.7c181.5,22.8,362,14.2,540.3-26.1c256.6-57.9,485.1-168,661-369.7
				c139.5-160,201.3-346,172.6-558.2C2985.6,1785.6,2992.4,1771.9,3014.3,1755.6z"
            />
            <path
              className="st1"
              style={{ fill: "#FF3F18" }}
              d="M3150.5,1481.1c11.1,118.6-44.5,206.6-136.1,274.5c-22,16.3-28.8,30-24.9,58.3
				c28.7,212.2-33.1,398.2-172.6,558.2c-175.9,201.7-404.4,311.8-661,369.7c-178.3,40.2-358.8,48.8-540.3,26.1
				c-207.5-26.1-405.4-83.1-583.8-195.7c-156.3-98.6-285-223.6-359.8-396.5c-52.6-121.6-66.1-248-44.4-378.3
				c2.3-14-0.5-21.7-13.3-30.2c-77.6-52-133.9-120.5-148.4-215.2c-36.9-240.9,177.3-387.5,357.7-339.7
				c52.2,13.8,100.5,42.3,150,65.2c12.1,5.6,20.2,9.2,33.4,0.2c144.7-98.7,303.8-163.3,474.9-199.5c95.4-20.2,191.6-34,289.2-33.3
				c19.3,0.1,23.1-10.3,27.6-24.7c52-165.7,104.4-331.2,156.6-496.8c18.5-58.8,46.6-75.3,106.7-62.4c144.7,30.9,289.4,61.3,433.9,93
				c17.9,3.9,28.1,0.6,40.1-13.4c122.7-142.7,313.1-77.5,374.4,31.5c76.6,136.4-9.2,306.7-167.3,332.2
				c-115,18.5-228.9-54.4-259.5-168.8c-6.5-24.2-17.9-32.2-40.8-36.9c-111.6-22.7-222.7-47.4-333.9-71.3c-8.8-1.9-17.8-2.9-29-4.7
				c-46.6,145-92.7,288.6-140.1,436c28,2.9,52.4,5.5,76.8,8c217.9,22.1,420,89.8,603.4,210.7c11.6,7.6,18.5,7.2,29.8-2
				c98.9-80.8,209.2-95.1,324.5-44.3C3080.8,1278.3,3139.6,1364.8,3150.5,1481.1z M2221.8,1946c96.7-0.1,182.7-85.8,182.3-181.6
				c-0.4-102-83.1-185.4-183.3-185.1c-97.3,0.3-182.1,83.5-182,178.4C2038.9,1861.5,2121.2,1946.1,2221.8,1946z M2265,2293.4
				c21-24.3,15.6-53.2-3.7-72.3c-26.8-26.6-61.4-34-88.3-18.6c-10.8,6.2-20.7,13.9-31.3,20.4c-185.3,112.6-378.9,130.1-579.5,46.7
				c-41.1-17.1-78.9-42.5-117.6-65c-28.8-16.8-65-10.9-92.6,17c-18.2,18.3-20.5,49.8-2.3,75.6c10.3,14.5,24.2,27.6,38.8,37.8
				c125.4,88,266.4,124.7,429.5,126.6c17.7-1.3,46.7-2.9,75.7-5.6c101.4-9.3,198.1-36,285.6-88.6
				C2211.2,2348,2240.4,2321.6,2265,2293.4z M1398.5,1946c90.9-0.2,178-89.4,177.6-182c-0.4-100.4-84.7-184.7-184.5-184.6
				c-98.5,0-182.4,84.6-182.2,183.7C1209.7,1863.3,1295.4,1946.2,1398.5,1946z"
            />
            <path
              className="st0"
              style={{ fill: "#fff" }}
              d="M2404.1,1764.4c0.4,95.8-85.6,181.5-182.3,181.6c-100.6,0.1-182.9-84.5-183-188.3
				c-0.1-95,84.7-178.1,182-178.4C2321,1578.9,2403.6,1662.3,2404.1,1764.4z"
            />
            <path
              className="st0"
              style={{ fill: "#fff" }}
              d="M2261.3,2221.1c19.3,19.1,24.7,48,3.7,72.3c-24.6,28.3-53.8,54.7-85.8,73.9
				c-87.5,52.6-184.2,79.3-285.6,88.6c-29,2.7-57.9,4.3-75.7,5.6c-163.1-1.8-304.1-38.6-429.5-126.6c-14.7-10.3-28.5-23.3-38.8-37.8
				c-18.2-25.8-15.9-57.4,2.3-75.6c27.7-27.9,63.8-33.7,92.6-17c38.7,22.6,76.5,47.9,117.6,65c200.6,83.5,394.2,65.9,579.5-46.7
				c10.6-6.4,20.6-14.1,31.3-20.4C2199.9,2187,2234.5,2194.5,2261.3,2221.1z"
            />
            <path
              className="st0"
              style={{ fill: "#fff" }}
              d="M1576.2,1763.9c0.4,92.6-86.7,181.8-177.6,182c-103.2,0.2-188.8-82.7-189.1-183
				c-0.2-99.1,83.7-183.7,182.2-183.7C1491.5,1579.2,1575.8,1663.5,1576.2,1763.9z"
            />
          </g>
          <g></g>
        </g>
      </g>
    </svg>
  );
};

export default Icon;
